'use es6';

import { Component } from 'react';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import SkeletonContainer from 'conversations-skeleton-state/components/SkeletonContainer';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import ReassignmentSelectInputPlaceholder from '../../reassignment/components/ReassignmentSelectInputPlaceholder';

//TODO: Move this into conversations-inbox-ui
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ThreadToolbarPlaceholder extends Component {
  render() {
    return /*#__PURE__*/_jsxs(SkeletonContainer, {
      background: OLAF,
      className: "justify-between p-left-5 align-center",
      height: 60,
      style: {
        minHeight: 60,
        borderBottom: `1px solid ${GREAT_WHITE}`
      },
      children: [/*#__PURE__*/_jsx(ReassignmentSelectInputPlaceholder, {}), /*#__PURE__*/_jsxs(SkeletonContainer, {
        className: "flex-row align-center",
        width: 211,
        children: [/*#__PURE__*/_jsx(SkeletonText, {
          width: 122
        }), /*#__PURE__*/_jsx(SkeletonText, {
          width: 48,
          className: "m-right-3"
        })]
      })]
    });
  }
}
ThreadToolbarPlaceholder.displayName = 'ThreadToolbarPlaceholder';